<template>
  <table
    v-if="changes && changes.length > 0"
    class="table entity-table entity-changes-table">
    <colgroup>
      <col class="col-20" />
      <col class="col-40" />
      <col />
      <col class="col-40" />
    </colgroup>

    <template v-if="fromToChanges?.length">
      <thead>
        <tr>
          <th>{{ capitalize($t('names.field')) }}</th>
          <th>{{ capitalize($t('states.before')) }}</th>
          <th></th>
          <th>{{ capitalize($t('states.after')) }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="propChange in fromToChanges"
          :key="propChange.property">
          <td>
            {{ label(propChange) }}
          </td>
          <template v-if="propChange.change?.diff?.length">
            <td></td>
            <td></td>
            <entity-change-list-diff
              :diff="propChange.change.diff"
              :field="label(propChange)" />
          </template>
          <template v-else>
            <entity-change-list-item :change="propChange.change.from" />
            <td>→</td>
            <entity-change-list-item :change="propChange.change.to" />
          </template>
        </tr>
      </tbody>
    </template>

    <template v-if="diffChanges?.length">
      <thead>
        <tr>
          <th>{{ capitalize($t('names.field')) }}</th>
          <th>{{ capitalize($t('actions.remove')) }}</th>
          <th></th>
          <th>{{ capitalize($t('actions.add')) }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="propChange in diffChanges"
          :key="propChange.property">
          <td>
            {{ label(propChange) }}
          </td>
          <entity-change-list-diff
            v-if="propChange.change?.diff?.length"
            :diff="propChange.change.diff"
            :field="label(propChange)" />
        </tr>
      </tbody>
    </template>
  </table>
</template>
<script setup lang="ts">
  import { capitalize, computed } from 'vue';

  import { IEntityChange } from '@/validator/Validatable';

  import EntityChangeListDiff from './EntityChangeListDiff.vue';
  import EntityChangeListItem from './EntityChangeListItem.vue';

  interface IProps {
    changes: IEntityChange<any>[];
  }

  const { changes } = defineProps<IProps>();

  const fromToChanges = computed(() => changes.filter((c) => !c.change?.diff?.length));
  const diffChanges = computed(() => changes.filter((c) => c.change?.diff?.length));

  function label(propChange: IEntityChange<any>) {
    return typeof propChange.property.label === 'function'
      ? propChange.property.label(propChange.updatedObject)
      : propChange.property.label;
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;

  .entity-changes-table {
    .col-40 {
      width: 40%;
    }
    .col-20 {
      width: 20%;
    }

    th:nth-child(2),
    td:nth-child(2) {
      text-align: right;
    }

    td:nth-child(2) {
      text-decoration: line-through;
    }

    th:nth-child(4),
    td:nth-child(4) {
      text-align: left;
    }

    td {
      .badge {
        margin-left: 0.6rem;
        margin-bottom: 0.3rem;
      }
    }
  }
</style>
